export default __webpack_public_path__ + "static/media/capsiflu.602ccdf9.png";